// @ts-ignore
import barba from "@barba/core";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Alpine from 'alpinejs';

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
}

export const barbaInit = () => {
  const loader = document.querySelector('#loader');

  barba.init({
    
    transitions: [
      {
        name: "default-transition",
        once(data: any) {

          // return gsap.from(data.next.container, {
          //   duration: 2,
          //   opacity: 0,
          // });
        },
        leave(data: any) {
          // make sure all ScrollTriggers are destroyed, remove if scrolltriggers are not used
          let triggers = ScrollTrigger?.getAll();
          triggers?.forEach((trigger) => {
            trigger.kill();
          });

          (window as any).Alpine.destroyTree(data.current.container);

          // return gsap.to(data.current.container, {
          //   opacity: 0,
          // });
        },
        beforeEnter: ({ next }) => {
          // keep cmplz classes
          const classesToKeep = document.body.className
            .split(" ")
            .map((className) => {
              return className.trim().startsWith("cmplz")
                ? className
                : undefined;
            })
            .filter((c) => c)
            .join(" ");

          /* Update wp body classes snippet found here: https://barba.js.org/docs/advanced/third-party/#WordPress */
          const matches = next.html.match(/<body.+?class="([^""]*)"/i);
          document.body.setAttribute(
            "class",
            ((matches && matches.at(1)) ?? "") + " " + classesToKeep,
          );
        },
        enter(data: any) {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
          });

          setTimeout(() => {
            loader?.classList.add('hidden'); // loader include is optional (base.twig)
          }, 1000);

          (window as any).Alpine.initTree(data.next.container);

          // return gsap.from(data.next.container, {
          //   opacity: 0,
          // });
        },
        afterLeave({ next }) {
          // replace header
          replaceContent(next, 'header#main-header')
        },
        after(data) {
          ScrollTrigger?.refresh();

          // after scrolltrigger refresh I need to reset scrollpos again
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
          });

          // hash seems to not be supported by default:
          if (data?.event?.target?.hash && window.location.hash !== data.event.target.hash) {
            setTimeout(() => {
              window.location.hash = data.event.target.hash;
            }, 10); // Small delay to prevent Barba.js from getting stuck
          }

          return;
        },
      },
    ],
  });
};

const replaceContent = (next, selector) => {
  // Create a temporary DOM from next.html
  const parser = document.createElement('div');
  parser.innerHTML = next.html;

  // Query the new menu from the parsed HTML
  const newMenu = parser.querySelector(selector);
  const currentMenu = document.querySelector(selector);

  // Replace current menu with the new one
  if (newMenu && currentMenu) {
    currentMenu.replaceWith(newMenu);
  }
}